var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGradeFill = function SvgGradeFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "grade_fill_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#grade_fill_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12 17.275-4.15 2.5a.9.9 0 0 1-.575.15.97.97 0 0 1-.525-.2 1.2 1.2 0 0 1-.35-.437.87.87 0 0 1-.05-.588l1.1-4.725L3.775 10.8A.96.96 0 0 1 3.5 9.725q.1-.274.3-.45.2-.174.55-.225l4.85-.425 1.875-4.45q.125-.3.388-.45t.537-.15.537.15.388.45l1.875 4.45 4.85.425q.35.051.55.225t.3.45.038.563a.96.96 0 0 1-.313.512l-3.675 3.175 1.1 4.725a.87.87 0 0 1-.05.588q-.125.262-.35.437a.97.97 0 0 1-.525.2.9.9 0 0 1-.575-.15z"
  }))));
};
export default SvgGradeFill;